import React from "react";
import { FiSearch } from "react-icons/fi";
import "./PageToolbar.css";

interface PageSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const PageSearchBar: React.FC<PageSearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  disabled = false,
  className = "",
}) => (
  <div className={`page-search-bar${className ? ` ${className}` : ""}`}>
    <FiSearch className="page-search-icon" aria-hidden />
    <input
      type="text"
      placeholder={placeholder}
      aria-label={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  </div>
);

export default PageSearchBar;
